export default __webpack_public_path__ + "static/media/profile_icon.141ef98d.png";